export * from "./pbrBaseMaterial.pure";

import "../../Materials/Textures/baseTexture.polynomial";
